<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app class="dp-seite">
      <dp-kopf :titel="titel" :untertitel="untertitel"><slot name="aktionen"/></dp-kopf>
      <slot name="leiste"/>
      <div class="dp-body">
        <v-alert v-if="dp.basis.schemaMissing" type="info" outlined>Die Dienstplanung ist für diesen Mandanten noch nicht eingerichtet.</v-alert>
        <template v-else-if="dp.basis.loaded">
          <v-alert v-if="!dp.regionValid && dp.plan" type="error" dense outlined>
            Holiday region is not valid for the tenant. – Die Feiertagsregion „{{ dp.region || 'leer' }}“ ist kein gültiges Bundesland;
            Vorschau und Veröffentlichung sind gesperrt.
          </v-alert>
          <slot/>
        </template>
      </div>
      <div v-if="zeigeEntwurf && dirty" class="dp-dirty elevation-6">
        <v-icon color="orange darken-2" class="mr-2">mdi-content-save-alert-outline</v-icon>
        <span><b>{{ dirty }}</b> vorgemerkte Änderung(en) sind noch nicht gespeichert.</span>
        <v-spacer/>
        <v-btn small text @click="$router.push('/dienstplanung/zuordnung#schritt-5')">Ansehen</v-btn>
      </div>
      <v-snackbar :value="snack.show" :timeout="7000" right :color="snack.color" @input="v => snack.show = v">
        <b>{{ snack.text }}</b>
        <template v-slot:action="{ attrs }">
          <v-btn icon color="white" v-bind="attrs" @click="snack.show = false"><v-icon>mdi-close-circle</v-icon></v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-main>
</template>

<script>
import {dirtyCount, dp} from '../store'
import DpKopf from './DpKopf'

// Common frame of the Dienstplanung pages.
export default {
  name: 'DpSeite',
  components: {DpKopf},
  props: {
    titel: {type: String, required: true},
    untertitel: {type: String, default: ''},
    snack: {type: Object, required: true},
    zeigeEntwurf: {type: Boolean, default: true},
  },
  computed: {
    dp: () => dp,
    dirty: () => dirtyCount(),
  },
}
</script>

<style scoped>
.dp-seite {
  flex: 1 1 auto;
  max-width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.dp-body {
  flex: 1 1 auto;
  overflow: auto;
  padding: 12px 16px 70px;
}
.dp-dirty {
  position: absolute;
  left: 16px;
  bottom: 12px;
  display: flex;
  align-items: center;
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 13px;
  z-index: 4;
  max-width: 520px;
}
</style>
